import { render, staticRenderFns } from "./PublicConversationDetails.vue?vue&type=template&id=ece2dd82&scoped=true"
import script from "./PublicConversationDetails.vue?vue&type=script&lang=js"
export * from "./PublicConversationDetails.vue?vue&type=script&lang=js"
import style0 from "./PublicConversationDetails.vue?vue&type=style&index=0&id=ece2dd82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece2dd82",
  null
  
)

export default component.exports